import { Connection, useIntegrationApp } from '@membranehq/react';
import { ArrowClockwise, Pencil } from '@phosphor-icons/react';
import { SideDropActions } from 'src/components/SideDropActions';
import { useNotification } from 'src/contexts/NotificationContext';

type IntegrationAppActionsProps = Connection & {
  canEdit?: boolean;
  onEditClick?: (integrationId: string) => void;
};

export const IntegrationAppActions = ({
  id,
  integrationId,
  canEdit = true,
  onEditClick,
}: IntegrationAppActionsProps) => {
  const integrationApp = useIntegrationApp();
  const notification = useNotification();

  const options = [
    ...(canEdit
      ? [
          {
            label: 'Edit',
            Icon: Pencil,
            onClick: () => {
              if (!integrationId) return;
              if (onEditClick) {
                onEditClick(integrationId);
              } else {
                integrationApp?.integration(integrationId).open();
              }
            },
          },
        ]
      : []),
    {
      label: 'Run Sync',
      Icon: ArrowClockwise,
      onClick: async () => {
        const flows = await integrationApp.flows.find({
          integrationId,
        });
        const batchFlow = flows?.items.find(
          ({ key }) => key === 'create-batch-call',
        );
        if (batchFlow) {
          await integrationApp.connection(id).flow(batchFlow.id).run({
            input: null,
          });
          return notification.success('Sync run successfully');
        }
        return notification.error('No sync flow found');
      },
    },
  ];

  return (
    <div className="flex justify-center items-center">
      <SideDropActions options={options} />
    </div>
  );
};
